module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Peace Love Wellness Mental Health Counseling","short_name":"PLW","description":"Relational, trauma-informed online therapy in New York for adults and couples seeking meaningful change.","start_url":"/","background_color":"#f8f5f0","theme_color":"#e68369","theme_color_in_head":false,"display":"standalone","icon":"static/images/favicon.webp","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"beabcdde97c564a380caac872a86a1fd"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
